


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ApplicationListController } from '@/services/request.service';
import { UnfinishedApplicationListInfoResponse } from '@/services/__model';

@Component
export default class Checklist extends Vue {
  public list: Array<UnfinishedApplicationListInfoResponse> = [];
  @Prop() public checkList!: any;
public newList:any=[]
  public created(): void {
    this.getList();
  }

  public getList(): void {
    ApplicationListController.getUnfinishedApplicationListList().then(res => {
      this.list = res.data;
      this.list.forEach(item=>{
        if(this.checkList.includes(item.studentId)){
      this.newList.push(item)
        }
      })
      
    });
  }

  public jumpToDetail(studentId: string): void {
    if (studentId) {
      this.$router.push({ name: 'studentDetail', query: { studentId } });
    }
  }
}
